<template>
  <div class="content">
    <div class="lineBox" style="padding-top:10px;border:0px;">
      <span class="h3" style="float:left;margin-top:5px;">Categorias </span>
      <input type="text" placeHolder="Nome" style="height:30px;margin-left:20px;float:left;" class="inputText inputSearch" v-model="search"/>
      <div @click="clearSearch()" style="float:left;margin-top:5px;"><OpaIcon name="broom" style="margin-left:5px;cursor:pointer" /></div>
      <button @click="newCategory()" style="float:right;width:186px;">Nova Categoria</button>
    </div>

    <div class="lineBox" style="margin-top:10px; min-height: 75px; min-width:1010px;">
      <div style="padding:10px; ">
        <table class="table" cellpadding="0" cellspacing="0" style="min-width:820px">
          <thead>
            <tr>
              <!-- <td style="text-align:left;">ID</td> -->

              <td style="text-align:left;">Nome</td>
              <td style="text-align:center;">Ordem</td>
              <td style="text-align:center;">Photo</td>
              <td style="text-align:center;">Ativo</td>
              <td style="text-align:center;">Ações</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, idx ) in filteredCategories" v-bind:key="idx">
              <!-- <td style="text-align:left;">{{p.ID}}</td> -->
              <td style="text-align:left;">
                <OpaContentEditable type="text" inputWidth="150px" v-model="p.name" @click="(e) => updateCategoryName(p, e)" />
              </td>
              <td style="text-align:center;cursor:pointer;width:80px">
                <OpaContentEditable type="number" decimal="0" inputWidth="30px" v-model="p.order" @click="(e) => updateCategoryOrder(p, e)" />
              </td>
              <td style="text-align:center;cursor:pointer;" @click="changeCategoryPhoto(p)">
                <font-awesome-icon v-if="!getCategoryPhoto(p)" style="font-size:18px;color:#12FCC4;margin:5px;"  :icon="['fal', 'edit']"/>
                <img :src="getCategoryPhoto(p)" style="max-width:60px;"  />
              </td>
              <td align="center">
                <template v-if="p.active === true">
                  <img src="img/on.png" @click="activeInativeCategory(p, false)" style="cursor:pointer;"/>
                </template>
                <template v-else>
                  <img src="img/off.png"  @click="activeInativeCategory(p, true)" style="cursor:pointer;"/>
                </template>
              </td>
              <td style="text-align:center;">
                <div style="display:inline-flex;">
                  <div v-if="p.id !== '0'" @click="removeCategory(p)">
                    <font-awesome-icon style="font-size:22px;color:#bb3f5c;margin:5px;"  :icon="['fal', 'trash-alt']"/>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <OpaModal v-model="showNewCategory" width="370" height="420" header="Nova Categoria">
      <div style="height:255px;overflow:auto; padding:20px;">
        <input type="text" class="inputText inputTag" placeholder="Nome" v-model="currentName"/>
        <br/><br/>
        <input id="selecao-arquivo" @change="saveNewIconImage($event)" type="file"  />
        <label for="selecao-arquivo">Novo Icone (tamanho ideal 32 x 32)</label>
        <br/><br/><br/>
        <div v-if="currentImageSrc" v-bind:class="{imgBgWhite: isDark===false}" style="height:160px;text-align:center;line-height:160px;vertical-align:middle;" >
          <img :src="currentImageSrc"/>
        </div>
        <br/><br/>
        <input id="selecao-photo" @change="saveNewPhotoImage($event)" type="file"  />
        <label for="selecao-photo">Nova foto (tamanho ideal 113 x 113)</label>
        <br/><br/><br/>
        <div v-if="currentPhotoSrc" style="height:160px;text-align:center;line-height:160px;vertical-align:middle;" >
          <img :src="currentPhotoSrc"/>
        </div>
      </div>

      <div class="modal_footer">
        <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="saveNewCategory()">Salvar</button>
        <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="closeCategory()">Cancelar</button>
      </div>
    </OpaModal>

    <OpaModal v-model="showEditCategory" width="370" height="420" header="Editar Imagem">
      <div style="height:255px;overflow:auto; padding:20px;">
        <input id="selecao-arquivo" @change="replaceIconImage($event)" type="file"  />
        <label for="selecao-arquivo">{{imageModalName}}</label>
        <br/><br/><br/>
        imagem para {{this.currentCategory.Name}}:
        <div v-if="tempImageSrc" v-bind:class="{imgBgWhite: isDark===false}" style="height:160px;text-align:center;line-height:160px;vertical-align:middle;" >
          <img :src="tempImageSrc"/>
        </div>
      </div>
      <div class="modal_footer">
        <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="updateCategory(true)">Salvar</button>
        <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="closeImageCategory()">Cancelar</button>
      </div>
    </OpaModal>

  </div>
</template>

<script>

import OpaIcon from '@/components/OpaIcon.vue'
import OpaContentEditable from '@/components/OpaContentEditable.vue'
import OpaModal from '@/components/OpaModal.vue'
import { EventBus } from '@/utils/event-bus'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Categories',
  data () {
    return {
      search: null,
      categories: [],
      showNewCategory: false,
      showEditCategory: false,
      currentImage: null,
      currentName: null,
      currentCategory: {},
      tempIcon: null,
      imageModalName: '',
      updatedObject: null
    }
  },

  components: {OpaIcon, OpaContentEditable, OpaModal},

  created () {
    this.getAllCategories()
  },

  computed: {
    ...mapGetters([ 'getProductApi', 'getOpaApi' ]),

    currentImageSrc () {
      if (this.currentImage) {
        return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/categories/' + this.currentImage
      } else {
        return null
      }
    },
    currentPhotoSrc () {
      if (this.currentPhoto) {
        return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/categories/photo/' + this.currentPhoto
      } else {
        return null
      }
    },

    tempImageSrc () {
      if (this.tempIcon && this.updatedObject === 'photo') {
        return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/categories/photo/' + this.tempIcon
      } else if (this.tempIcon) {
        return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/categories/' + this.tempIcon
      } else if (this.currentCategory.Icon){
        return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/categories/' + this.currentCategory.Icon
      } else {
        return null
      }
    },

    isDark () {
      return this.getCompany().dark
    },

    filteredCategories () {
      if (this.search) {
        let ret = this.categories.filter(p => p.name.toLocaleLowerCase().indexOf(this.search.toLowerCase()) > -1)
        return ret
      } else {
        return this.categories
      }

    }
  },

  methods: {

    ...mapGetters([ 'getAdmin', 'getCompany' ]),

    getAllCategories () {
      let vm = this
      axios.get(this.getProductApi + '/categories?unfiltered=true&company_id=' + this.getCompany().companyId)
        .then((r) => {
          vm.categories = r.data.filter((c) => { return !c.parent_id}).sort((a,b) => a.order - b.order)
        })
        .catch((e) => {
          console.log(e)
        })
    },

    getCategoryImage (c) {
      let icon = c.icon
      if (icon && c.id !== '0') {
        return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/categories/' + icon
      } else {
        return null
      }
    },

    getCategoryPhoto (c) {
      let photo = c.photo
      if (photo) {
        //TODO fix path
        return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/categories/photo/' + photo
      } else {
        return null
      }
    },

    newCategory () {
      this.showNewCategory = true
    },

    changeCategoryImage (c) {
      this.currentCategory = c
      this.showEditCategory = true
      this.imageModalName = 'Novo icone (tamanho ideal 32 x 32)'
      this.updatedObject = 'icon'
    },

    changeCategoryPhoto (c) {
      this.currentCategory = c
      this.showEditCategory = true
      this.imageModalName = 'Nova foto (tamanho ideal 113 x 113)'
      this.updatedObject = 'photo'
    },

    closeCategory () {
      this.showNewCategory = false
      this.currentImage = null
      this.currentPhoto = null
      this.currentName = null
    },

    closeImageCategory () {
      this.showEditCategory = false
      this.currentCategory = {}
      this.tempIcon = null
    },

    updateCategoryName (c, e) {
      c.name = e
      this.currentCategory = c
      this.updateCategory(false)
    },

    updateCategoryOrder (c, e) {
      c.order = Number(e)
      this.currentCategory = c
      this.updateCategory(false)
    },

    updateCategory (image) {
      EventBus.$emit('showLoading', true)
      let vm = this
      axios.put(this.getProductApi + '/categories',
      {
        id: this.currentCategory.id,
        name: this.currentCategory.name,
        parent_id: null,
        icon: (image &&  this.updatedObject === 'icon' ? this.tempIcon : this.currentCategory.icon),
        photo: (image &&  this.updatedObject === 'photo' ? this.tempIcon : this.currentCategory.photo),
        order: this.currentCategory.order,
        active: this.currentCategory.active
      })
        .then((r) => {
          this.categories.forEach((c) => {
            if(c.id === r.data.id){
              c.name = r.data.name
              c.icon = r.data.icon
              c.photo = r.data.photo
            }
          })
          vm.categories.sort((catA, catB) => catA.order - catB.order)
          vm.showEditCategory = false
          vm.currentCategory = {}
          vm.tempIcon = null
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'success', 'categoria salva com sucesso')
        })
        .catch((e) => {
          console.log(e)
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'error', 'erro ao salvar categoria')
        })
    },

    activeInativeCategory (category, action) {
      let vm = this
      category.active = action
      vm.currentCategory = category
      vm.updateCategory(action)
    },

    saveNewCategory () {
      let vm = this
      if(!vm.currentName){
        EventBus.$emit('showAlert', 'error', 'Digite um nome para a categoria')
        return
      }
      EventBus.$emit('showLoading', true)
      axios.post(this.getProductApi + '/categories/',
      {
        name: vm.currentName,
        parent_id: null,
        icon: vm.currentImage,
        photo: vm.currentPhoto,
        order: 0,
        active: true
      })
        .then((r) => {
          this.categories.push(r.data)
          vm.showNewCategory = false
          vm.currentName = null
          vm.currentImage = null
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'success', 'categoria salva com sucesso')
        })
        .catch((e) => {
          console.log(e)
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'error', 'erro ao salvar categoria')
        })
    },

    replaceIconImage (e) {
      if(this.updatedObject !== 'photo') {
        this.saveIconImage (e, this.currentCategory, false, '')
      } else {
        this.saveIconImage (e, this.currentCategory, false, this.updatedObject)
      }
    },

    saveNewIconImage (e) {
      this.saveIconImage(e, null, true, '')
    },

    saveNewPhotoImage (e) {
      this.saveIconImage(e, null, true, 'photo')
    },

    saveIconImage (e, cat, isNew, type) {
      let vm = this
      if(e.target.value) {
        let bodyFormData = new FormData()
        // let blob = new Blob(, { type: 'image/png' })
        bodyFormData.append('file', e.target.files[0])
        EventBus.$emit('showLoading', true)
        axios({
          method: 'post',
          url: this.getOpaApi + '/files/company/' + this.getCompany().companyId + '/categories' + '/' + type,
          data: bodyFormData,
          config: { headers: {'Content-Type': 'form-data' }}
          })
          .then(function (response) {
              //handle success
              if (isNew && type === 'photo') {
                vm.currentPhoto = response.data.file_name
              }else if (isNew) {
                vm.currentImage = response.data.file_name
              } else {
                vm.tempIcon = response.data.file_name
              }
            EventBus.$emit('showLoading', false)
          })
          .catch(function (response) {
              //handle error
              console.log(response)
              EventBus.$emit('showLoading', false)
              EventBus.$emit('showAlert', 'error', 'erro ao subir imagem')
          })
      }
    },

    removeCategory (c) {
      if (confirm('Deseja realmente remover essa categoria?')){
        let vm = this
        EventBus.$emit('showLoading', true)
        axios.delete(this.getProductApi + '/categories/' + c.id)
          .then(() => {
            vm.categories = vm.categories.filter(cc => cc.id !== c.id)
            EventBus.$emit('showLoading', false)
          })
          .catch((e) => {
            console.log(e)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao remover categoria')
          })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.imgBgWhite {
  background-color:#ffffff;
}

input[type='file'] {
  display: none;


}

label {
  float: left;
  width:320px;
  height: 40px;
  background-color: #12FCC4;
  border: 0px;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  color: #423D4E;
  font-family: Roboto;
  font-size: 14px;
  line-height: 40px;
  vertical-align: middle;
  text-align:center;
  font-weight: 500;
  text-decoration:none;
}
</style>
